import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, TouchableOpacity, StatusBar, TextInput, I18nManager} from 'react-native';
import Colors, {colorDark, colorPrimary, colorSecondPrimary} from "../tools/Colors"
import {moderateScale} from "../tools/Scaling";
import connect from "react-redux/es/connect/connect";
import Fumi from "./input/Fumi";
import Hoshi from "./input/Hoshi";
import Kaede from "./input/Kaede";
import Akira from "./input/Akira";
import CostumeFumi from "./input/CostumeFumi";
import HMTextView from "./HMTextView";

//import Fumi from "react-native-textinput-effects/lib/Fumi";
import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import AntDesign from 'react-native-vector-icons/dist/AntDesign';
import Entypo from 'react-native-vector-icons/dist/Entypo';
import EvilIcons from 'react-native-vector-icons/dist/EvilIcons';
import Feather from 'react-native-vector-icons/dist/FontAwesome';
import Foundation from 'react-native-vector-icons/dist/Foundation';
import MaterialCommunityIcons from 'react-native-vector-icons/dist/MaterialCommunityIcons';
import Octicons from 'react-native-vector-icons/dist/Octicons';
import SimpleLineIcons from 'react-native-vector-icons/dist/SimpleLineIcons';
import Zocial from 'react-native-vector-icons/dist/Zocial';
import {isMobile} from "react-device-detect";

class HMTextInputEfects extends Component {

    render() {
        let {styleRoot, ref, iconClass, iconName, secureTextEntry, label, type, number, underline, icon, placeholder, keyboardType, requireField, onChangeText, textStyle, style, value, containerStyle, themeColor, editable, _height, _width, _multiline, cammas, textCenter, placeholderColor, border} = this.props;
        return (
            <View style={[styleRoot, {
                flexDirection: 'row',
                //    backgroundColor: '#eedd3e',
                //  marginVertical: moderateScale(6),
                alignItems: 'center'
            }]}>

                <HMTextView
                    type={"bold"}
                    text={requireField ? "*" : " "}
                    style={[textStyle, {
                        color: "red",
                        fontSize: moderateScale(18),
                        textAlign: 'center',
                        marginStart: moderateScale(requireField ? 0 : 1)
                    }]}/>


                {

                    this.TypeInputText()

                }

            </View>

        );
    }

    TypeInputText() {
        let {
            onRef,
            containerInputStyle,
            containerStyle,
            border,
            _ref,
            lengthWord,
            placeholder,
            multiline,
            onSubmitEditing,
            returnKeyType,
            keyboardType,
            autoFocus,
            _scroll,
            refName,
            iconClass, iconName, secureTextEntry, descLabel, label, type, number, underline, icon, requireField, onChangeText, textStyle, style, styleInput, value, themeColor, editable, _height, _width, _multiline, cammas, textCenter, placeholderColor
        } = this.props;
        iconClass = FontAwesomeIcon;

        switch (type) {
            case "Fumi":
                return (

                    <Fumi
                        {...this.props}
                        //  containerStyle={containerStyle}
                        border={border}
                        _ref={_ref}
                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        descLabel={descLabel}
                        iconClass={iconClass}
                        iconName={iconName}
                        iconColor={Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        inputPadding={moderateScale(16)}
                        secureTextEntry={secureTextEntry}
                        inputStyle={{
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        style={[{
                            marginVertical: moderateScale(6),
                            //   marginTop: moderateScale(12),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',


                        }, styleInput]}
                        multiline={multiline ? true : false}
                        keyboardType={keyboardType ? keyboardType : "default"}
                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        //   refName={refName}
                        lengthWord={lengthWord}

                    />

                );
                break;

            case "Hoshi":
                return (
                    <Hoshi
                        {...this.props}
                        _ref={_ref}
                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        iconClass={iconClass}
                        iconName={iconName}
                        iconColor={Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        inputPadding={moderateScale(16)}
                        secureTextEntry={secureTextEntry}
                        inputStyle={{
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        style={[{
                            //  marginVertical:moderateScale(6),
                            marginTop: moderateScale(12),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',

                        }, styleInput]}
                        multiline={multiline ? true : false}
                        keyboardType={keyboardType ? keyboardType : "default"}
                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        refName={refName}
                        lengthWord={lengthWord}

                    />
                );
                break;
            case "Kaede":
                return (
                    <Kaede
                        {...this.props}
                        _ref={_ref}
                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        iconClass={iconClass}
                        iconName={iconName}
                        iconColor={Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        inputPadding={moderateScale(16)}
                        secureTextEntry={secureTextEntry}
                        inputStyle={{
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        style={[{
                            //  marginVertical:moderateScale(6),
                            marginTop: moderateScale(12),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',

                        }, styleInput]}
                        multiline={multiline ? true : false}
                        keyboardType={keyboardType ? keyboardType : "default"}
                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        refName={refName}
                        lengthWord={lengthWord}

                    />
                );
                break;
            case "Akira":
                return (
                    <Akira
                        {...this.props}
                        _ref={_ref}
                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        iconClass={iconClass}
                        iconName={iconName}
                        iconColor={Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        inputPadding={moderateScale(16)}
                        secureTextEntry={secureTextEntry}
                        inputStyle={{
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        style={[{
                            //  marginVertical:moderateScale(6),
                            marginTop: moderateScale(12),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',

                        }, styleInput]}
                        multiline={multiline ? true : false}
                        keyboardType={keyboardType ? keyboardType : "default"}
                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        refName={refName}
                        lengthWord={lengthWord}
                        borderColor={Colors.blue}

                    />
                );
                break;

            case "CostumeFumi":
                return (
                    <CostumeFumi
                        {...this.props}
                        //  containerStyle={containerStyle}
                        border={border}
                        _ref={_ref}
                        onRef={onRef}
                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        iconClass={iconClass}
                        iconName={iconName}
                        iconColor={this.props.editable === false ? Colors.colorDarkText : Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        //  inputPadding={moderateScale(8)}
                        secureTextEntry={secureTextEntry}
                        inputStyle={{
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        style={[{
                            //  marginVertical:moderateScale(6),
                            //   marginTop: moderateScale(12),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',


                        }, containerStyle, styleInput]}
                        //containerInputStyle={containerInputStyle}
                        multiline={multiline ? true : false}
                        keyboardType={Platform.OS === "web" && !(isMobile) ? "default" : keyboardType}

                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        refName={refName}
                        lengthWord={lengthWord}
                    />
                );
                break;
            default:
                return (
                    <Hoshi
                        {...this.props}
                        // this is used as active border color
                        borderColor={'#b76c94'}
                        // active border height
                        borderHeight={3}
                        // inputPadding={16}
                        // this is used to set backgroundColor of label mask.
                        // please pass the backgroundColor of your TextInput container.
                        backgroundColor={'#F9F7F6'}
                        border={border}

                        _ref={_ref}

                        value={value}
                        onChangeText={onChangeText}
                        label={label}
                        iconClass={iconClass}
                        iconName={'user'}
                        iconColor={Colors.blue}
                        iconSize={moderateScale(20)}
                        iconWidth={moderateScale(40)}
                        inputPadding={moderateScale(0)}
                        secureTextEntry={secureTextEntry}
                        style={{
                            //  marginVertical:moderateScale(6),
                            // marginTop: moderateScale(18),
                            width: "93%",
                            //  height: moderateScale(20),
                            alignSelf: 'center',
                            textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        }}
                        multiline={multiline ? true : false}
                        keyboardType={keyboardType ? keyboardType : "default"}
                        placeholder={placeholder}
                        onSubmitEditing={onSubmitEditing}
                        returnKeyType={returnKeyType ? returnKeyType : 'next'}
                        autoFocus={autoFocus}
                        _scroll={_scroll}
                        refName={refName}
                        lengthWord={lengthWord}
                    />
                );
                break;
        }

    }
}


const styles = StyleSheet.create({
    containerBack: {
        backgroundColor: Colors.backgroundColorDarker,
        flexDirection: "row",
        //   alignItems: Platform.OS === "ios" ? "flex-end" : "center",
        // justifyContent: "space-between",
        height: Platform.OS === "ios" ? moderateScale(70) : moderateScale(50),
        paddingBottom: Platform.OS === "ios" ? moderateScale(15) : 0,
        paddingHorizontal: moderateScale(10)
    },
    container: {
        backgroundColor: Colors.backgroundColorDarker,
        flexDirection: "row",
        // alignItems: Platform.OS === "ios" ? "flex-end" : "center",
        // justifyContent: "flex-end",
        height: Platform.OS === "ios" ? moderateScale(75) : moderateScale(55),
        paddingBottom: Platform.OS === "ios" ? moderateScale(15) : 0,
        paddingHorizontal: moderateScale(10)

    },
    rowContainer: {
        flexDirection: "row",
    }
});


const mapStateToProps = (state) => {

    return {}
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMTextInputEfects);
